import { render, staticRenderFns } from "./MortgageDeal.vue?vue&type=template&id=f468ab5c&scoped=true&"
import script from "./MortgageDeal.vue?vue&type=script&lang=js&"
export * from "./MortgageDeal.vue?vue&type=script&lang=js&"
import style0 from "./MortgageDeal.vue?vue&type=style&index=0&id=f468ab5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f468ab5c",
  null
  
)

export default component.exports